import React from 'react';
import { EditIsDynamicDefaultField } from '../EditIsDynamicDefaultField';
import { EditIsProtectedField } from '../EditIsProtectedField';
import { EditHelperTextField } from './EditHelperTextField';
import { EditIsDuplicableDisplayField } from './EditIsDuplicableDisplayField';
import { EditIsRequiredField } from './EditIsRequiredField';
import { EditNameField } from './EditNameField';
import { EditSubtextField } from './EditSubtextField';

export type BaseEditGenericFieldFormProps = {
  isInDuplicableSection: boolean;
  isInspectionDate?: boolean;
  isEditMode: boolean;
  prefix?: string;
};

type EditGenericFieldFormProps = {
  children?: React.ReactNode;
} & BaseEditGenericFieldFormProps;

// this is rendered within FinalForm so the inputs are managed by it
export function EditGenericFieldForm(props: EditGenericFieldFormProps) {
  const {
    children,
    isInspectionDate,
    isEditMode,
    isInDuplicableSection,
    ...fieldProps
  } = props;
  return (
    <>
      <EditNameField {...fieldProps} />
      <EditIsRequiredField
        isInspectionDate={isInspectionDate}
        {...fieldProps}
      />
      <EditIsProtectedField {...fieldProps} />
      <EditSubtextField isEditMode={isEditMode} {...fieldProps} />
      <EditHelperTextField {...fieldProps} />
      {children}
      <EditIsDynamicDefaultField {...fieldProps} />
      <EditIsDuplicableDisplayField
        isInDuplicableSection={isInDuplicableSection}
        {...fieldProps}
      />
    </>
  );
}
